import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "forge_token";
export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

api.interceptors.request.use((config) => {
  const t = auth.getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      auth.clear();
      const p = window.location.pathname;
      if (!p.startsWith("/login") && !p.startsWith("/register") && p !== "/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(e);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Xəta baş verdi. Yenidən cəhd et.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function registerUser(payload) { const { data } = await api.post("/auth/register", payload); return data; }
export async function loginUser(payload) { const { data } = await api.post("/auth/login", payload); return data; }
export async function fetchMe() { const { data } = await api.get("/auth/me"); return data; }

export const PROVIDER_META = {
  anthropic: {
    label: "Claude",
    sub: "Anthropic",
    models: ["claude-sonnet-4-6", "claude-opus-4-6", "claude-sonnet-5", "claude-haiku-4-5-20251001"],
    color: "#D97757",
  },
  openai: {
    label: "OpenAI",
    sub: "GPT",
    models: ["gpt-5.4", "gpt-5.4-mini", "gpt-5.5", "gpt-4o"],
    color: "#10B981",
  },
  gemini: {
    label: "Gemini",
    sub: "Google",
    models: ["gemini-3.1-pro-preview", "gemini-3-flash-preview", "gemini-2.5-flash"],
    color: "#4285F4",
  },
};

export const STACK_META = {
  static: { label: "Statik", sub: "HTML / CSS / JS", desc: "Frontend saytlar", backend: false },
  php: { label: "PHP + MySQL", sub: "Full-stack", desc: "Backend + verilənlər bazası", backend: true },
};

export function previewUrl(projectId, v) {
  return `${API}/projects/${projectId}/preview/?v=${v}`;
}

export function downloadUrl(projectId) {
  return `${API}/projects/${projectId}/download`;
}

export async function githubPush(projectId, payload) {
  const { data } = await api.post(`/projects/${projectId}/github/push`, payload);
  return data;
}

export async function startGeneration(projectId, prompt) {
  return api.post(`/projects/${projectId}/generate`, { prompt });
}

export async function getStatus(projectId) {
  const { data } = await api.get(`/projects/${projectId}/status`);
  return data;
}
